import { customerHasRefundFlaggedVariations } from 'src/data/accessRights';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useCustomerHasRefundFlaggedVariations = () => {
  const currentCustomer = useCurrentCustomer();

  return customerHasRefundFlaggedVariations(currentCustomer);
};
